import React from 'react';
import type { ConsentProfile } from 'types/nhis';
import { DetailContainer, DetailTitle, DetailTable, DetailRow, DetailLabel, DetailValue } from './styles';

/** 동의 4: 개인정보 국외 이전 동의 — 세 판 공통 (CONSENT_VERSION 20261102 / CONSENT_VERSION_CARINGNOTE 20261102-CN / CONSENT_VERSION_KMRS 20261102-KMRS) */
const ConsentDetail4: React.FC<{ profile?: ConsentProfile }> = ({ profile }) => (
  <DetailContainer>
    <DetailTitle $kmrs={profile === 'kmrs'}>개인정보 국외 이전 동의</DetailTitle>
    <DetailTable>
      <tbody>
        <DetailRow>
          <DetailLabel>이전받는 자</DetailLabel>
          <DetailValue>
            아래 사업자 중 회사가 지정한 AI 모델의 제공사 한 곳에 이전됩니다.
            <ul>
              <li>OpenAI, L.L.C. (개인정보 보호 연락처: dpo@openai.com)</li>
              <li>Anthropic, PBC (개인정보 보호 연락처: privacy@anthropic.com)</li>
              <li>
                Google LLC (
                <a
                  href="https://support.google.com/policies/contact/general_privacy_form"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  개인정보 문의 양식
                </a>
                )
              </li>
              <li>SpaceX Super Intelligence LLC (개인정보 보호 연락처: privacy@x.ai)</li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>이전되는 국가</DetailLabel>
          <DetailValue>미국 (USA)</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>이전 일시 및 방법</DetailLabel>
          <DetailValue>담당 약사가 AI 검토를 요청하는 시점에 API를 통해 암호화(TLS) 전송</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>이전되는 항목</DetailLabel>
          <DetailValue>
            <strong>
              환자가 선택한 투약 이력과 담당 약사가 입력한 건강 정보를 가명처리(이름 등을 지워 누구인지 바로 알 수 없게
              처리)한 자료
            </strong>
            <ul>
              <li>기본 정보: 성별, 연령대</li>
              <li>투약 정보: 처방·조제된 의약품(이름·코드)과 용법·용량, 처방 일자·기간</li>
              <li>의료기관 정보: 의료기관명을 대신한 가명코드, 의료기관 종류·진료과</li>
              <li>약사 입력 정보: 일반의약품·건강기능식품 복용 내역, 질병, 알레르기, 상담 내용</li>
            </ul>
            <p className="note">
              ※ 성명, 연락처, 주민등록번호 등 직접 식별 정보는 전송되지 않습니다.
            </p>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>가명처리 방법</DetailLabel>
          <DetailValue>
            <ul>
              <li>직접 식별자 제거(이름·연락처·주민등록번호 미전송)</li>
              <li>연령을 연령대로 변환</li>
              <li>의료기관명을 검토 건별 가명코드(A병원, B병원 등)로 대체</li>
              <li>보건복지부 보건의료데이터 활용 가이드라인의 가명처리 방법을 참고합니다</li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>이전 목적</DetailLabel>
          <DetailValue>
            가명처리된 데이터를 활용하여, <strong>약사의 심층 검토 업무를 보조하기 위한 약물학적 평가 데이터(전문가용 초안 리포트) 산출</strong>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>보유 및 이용 기간</DetailLabel>
          <DetailValue>
            <strong>전송된 데이터는 AI 보조 분석 결과 반환 후 각 제공사의 정책에 따라 최대 55일 보관된 뒤 자동으로 영구 삭제됩니다.</strong>
            <p className="note">
              ※ 위 사업자의 기업용 API 정책에 따라 전송된 데이터는 AI 모델 학습에 사용되지 않습니다.
            </p>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>AI 자동화 분석 안내 / 설명 요구권</DetailLabel>
          <DetailValue>
            본 서비스는 AI가 약물학적 평가를 자동 수행하며, 최종 결과는 담당 약사가 검증 후 확정합니다. 환자님은 AI 분석 결과에 대해 담당 약사에게 설명을 요구하실 수 있습니다.
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>동의 거부 권리 및 불이익</DetailLabel>
          <DetailValue>
            귀하는 개인정보의 국외 이전을 거부할 수 있으며, 거부는 본 동의서의 체크박스를 선택하지 않는 방식으로 가능합니다.
            <p className="note">
              ※ 단, 필수적인 AI 약물 분석 절차 진행이 불가능해져, 약사의 정밀 위험도 분석 서비스를 받으실 수 없습니다.
            </p>
          </DetailValue>
        </DetailRow>
      </tbody>
    </DetailTable>
  </DetailContainer>
);

export default ConsentDetail4;
